import React from 'react';
import { Headline } from './components/Headline';
import { HeroImage } from './components/HeroImage';
import { SymptomIdentification } from './components/SymptomIdentification';
import { ProblemAgitation } from './components/ProblemAgitation';
import { Promise } from './components/Promise';
import { ProductPresentation } from './components/ProductPresentation';
import { Outcomes } from './components/Outcomes';
import { Science } from './components/Science';
import { WhoItsFor } from './components/WhoItsFor';
import { Testimonials } from './components/Testimonials';
import { WhatYouGet } from './components/WhatYouGet';
import { PriceAndCTA } from './components/PriceAndCTA';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { UrgencyClose } from './components/UrgencyClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-sage-light selection:text-forest-green" data-id="element-0">
      <main data-id="element-1">
        <Headline data-id="element-2" />
        <HeroImage data-id="element-3" />
        <SymptomIdentification data-id="element-4" />
        <ProblemAgitation data-id="element-5" />
        <Promise data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <Outcomes data-id="element-8" />
        <Science data-id="element-9" />
        <WhoItsFor data-id="element-10" />
        <Testimonials data-id="element-11" />
        <WhatYouGet data-id="element-12" />
        <PriceAndCTA data-id="element-13" />
        <Guarantee data-id="element-14" />
        <FAQ data-id="element-15" />
        <UrgencyClose data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}